// Safe diagnostic logger.
//
// The host environment (Vercel / browser extensions in the wild) instruments
// console.* methods and previously caused infinite-recursion blowups when our
// code called console.warn — see prior sweeps replacing console.error first,
// then console.warn. To stay decoupled from console entirely this routes to
// an opt-in `window.__origLog` shim if one is installed, and is otherwise a
// no-op. Either way: never re-enters console.*.
//
// In dev you can wire it back up from the browser console:
//   window.__origLog = console.log.bind(console)
//
export function log(...args) {
  try {
    if (typeof window !== 'undefined') window.__origLog?.(...args)
  } catch { /* swallow — logging must never throw into callers */ }
}
